import { render, staticRenderFns } from "./PageMenuMobile.vue?vue&type=template&id=61563bc2&"
import script from "./PageMenuMobile.vue?vue&type=script&lang=js&"
export * from "./PageMenuMobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports